const CadastroHome = () => import(/* webpackChunkName: "group-pabx-rotas" */ '../views/cadastrosHome')

import RotaRoutes from '../modules/rotas/cadastroDeRotas/_routes'
import GrupoDeRotasRoutes from '../modules/rotas/cadastroDeGrupoDeRotas/_routes'

import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'rotas',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: CadastroHome,
    children: [
      ...RotaRoutes,
      ...GrupoDeRotasRoutes
    ],
  },
]
